import {
  BannerAcmp,
  BannerBce,
  BannerCmst2,
  BannerDscs,
  BannerFossep,
  BannerJace,
  BannerJae,
  BannerJas,
  BannerTramites,
  CampusRomero,
  Cencosud,
  Civime,
  Convenios,
  ImgFovime,
  ImgWorks,
  JovenesProductivos,
  SdaceApplications,
  SkyAirlines,
  TestVocacional,
} from "../images";

export const departments = [
  {
    id: "jace-01",
    title: "jace",
    titleLarge: "Jefatura de Administración de Casas del Ejército",
    banner: BannerJace,
    externalUrl: "https://sdace.jbiene.com/",
  },
  {
    id: "jae-03",
    title: "jae",
    banner: BannerJae,
    titleLarge: "Jefatura de Apoyo Educativo",
    externalUrl: "https://sdae.jbiene.com/",
  },
  {
    id: "dae-02",
    title: "das",
    titleLarge: "Departamento de Apoyo Social",
    banner: BannerJas,
    url: "/sub-departments/dae-02",
  },
  {
    id: "tramites-12",
    title: "DSCS",
    titleLarge: "Departamento de Supervisión de Calidad del Servicio",
    banner: BannerDscs,
    externalUrl: "https://dscs.jbiene.com/",
  },
  {
    id: "fossep-04",
    title: "fossep",
    banner: BannerFossep,
    titleLarge: "Fondo Solidario de Sepelio del Ejército del Perú",
    externalUrl: "https://www.fossep.com.pe/",
  },
  {
    id: "fovime-05",
    title: "fovime",
    banner: ImgFovime,
    titleLarge: "Fondo de Vivienda Militar del Ejército",
    externalUrl: "https://fovime.com/",
  },
  {
    id: "acmp-06",
    title: "acmp",
    banner: BannerAcmp,
    titleLarge: "Asociación Círculo Militar del Perú",
    externalUrl: "https://www.circulomilitardelperu.com/",
  },
  {
    id: "bce-07",
    title: "b.c.e",
    banner: BannerBce,
    titleLarge: "Bazar Central del Ejército",
    externalUrl: "http://www.tubazar.com.pe/",
  },
  {
    id: "cmsts-08",
    title: "cmsts",
    banner: BannerCmst2,
    titleLarge: "Círculo Militar Supervisores Tecnicos de Sub Oficiales",
    externalUrl: "https://circulomilitar-sts.com/",
  },
  {
    id: "flip-book-pages",
    title: "catálogo",
    banner: Convenios,
    titleLarge: "Catálogo",
    url: "/flip-book",
  },
  {
    id: "tramites-09",
    title: "SISBIENE TRAMITES",
    banner: BannerTramites,
    titleLarge: "Solicitud de convenios estudios superiores",
    externalUrl: "https://tramites.jbiene.com/",
  },
  {
    id: "tramites-10",
    title: "Civime",
    banner: Civime,
    titleLarge: "Centro de Idiomas",
    externalUrl: "https://www.civime.edu.pe/",
  },
  {
    id: "tramites-11",
    title: "Propuesta",
    banner: ImgWorks,
    titleLarge: "Oportunidad laboral",
    url: "/job-opportunity",
  },
  {
    id: "test-vocacional",
    title: "Test",
    titleLarge: "Test vocacional de intereses profesionales",
    banner: TestVocacional,
    externalUrl: "https://testvocacional.trabajo.gob.pe/",
  },
  {
    id: "discount-coupons",
    title: "Códigos Cencosud",
    titleLarge: "Solicitud de descuento para personal retirado y esposos/as",
    banner: Cencosud,
    externalUrl: "https://jbiene.cobiene.com/discount-codes-requests/register",
  },
  {
    id: "free-courses",
    title: "Cursos Gratuitos",
    titleLarge: "Jovenes productivos clases virtuales gratuita",
    banner: JovenesProductivos,
    externalUrl: "https://aulavirtual.jovenesproductivos.gob.pe/",
  },
  {
    id: "sky-airline",
    title: "Sky Airline",
    titleLarge: "Solicitud de código de descuento Sky Airline",
    banner: SkyAirlines,
    externalUrl: "https://tramites.jbiene.com/sky/requests/new",
  },
  {
    id: "solicitud-sdace",
    title: "SDACE",
    titleLarge: "Solicitud de casa (SDACE)",
    banner: SdaceApplications,
    externalUrl:
      "https://tramites.jbiene.com/entities/sdace/sdace-requests/new",
  },
  {
    id: "solicitud-sdace",
    title: "Beca de Estudio",
    titleLarge: "Solicitud Beca de Estudio",
    banner: CampusRomero,
    externalUrl:
      "https://tramites.jbiene.com/applications-study-grants/requests/new",
  },
];
